import api from "@/api";

const state = {
  status: "",
  tabs: []
};

const getters = {};

const actions = {
  getTabs: ({ commit }, { url, params, keys }) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      api
        .get(url, { params: params ?? {} })
        .then((resp) => {
          commit("success");

          const keyRoot = { label: "Name", name: "Id" };
          Object.assign(keyRoot, keys);

          let tabs = [];
          resp.data.forEach((tab) => {
            tabs.push({
              label: tab[keyRoot.label],
              name: `${tab[keyRoot.name]}`
            });
          });

          commit("tabs", tabs);
          resolve(resp);
        })
        .catch((error) => {
          commit("error");
          reject(error);
        });
    });
  }
};

const mutations = {
  loading: (state) => {
    state.status = "loading";
  },
  success: (state) => {
    state.status = "success";
  },
  error: (state) => {
    state.status = "error";
  },
  tabs: (state, tabs) => {
    state.tabs = tabs;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
